import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';

import { IPmListFilterRaw } from '../interfaces/IPmListFilterRaw';
import { IPmListFilterParams } from '../interfaces/IPmListFilterParams';
import { getRawFilter } from './getRawFilter';

export const getRequestFilterData = (searchValue: string, filter?: IPmListFilterParams): IPmListFilterParams | null => {
  const isFilterOn = !!getStorageItem(StorageNamesEnum.PM_FILTER_ON);

  if (filter) {
    return isFilterOn && filter ? { ...filter } : null;
  }
  const rawFilter: IPmListFilterRaw = getRawFilter();

  if (!rawFilter) {
    return null;
  }

  let requestData: IPmListFilterParams | null = null;

  if (isFilterOn) {
    requestData = searchValue ? { ...rawFilter, searchString: searchValue } : { ...rawFilter };
  } else {
    requestData = searchValue ? { searchString: searchValue } : {};
  }

  return requestData;
};
